// extracted by mini-css-extract-plugin
export var addToCartButton = "_q8-b";
export var arrowButtonContainer = "_q8-9";
export var arrowButtonIcon = "_q8-a";
export var carouselArrowButton = "_q8-6";
export var carouselElementContainer = "_q8-1";
export var left = "_q8-7";
export var productDisplayCarouselContainer = "_q8-0";
export var productTileContainer = "_q8-2";
export var productTileImage = "_q8-4";
export var productTileImageContainer = "_q8-3";
export var productTileTitle = "_q8-5";
export var right = "_q8-8";
export var sliderOverflow = "_q8-c";